String.prototype.convertToNumber = function () {
  const result = this.replace(/[^\d.-]/g, "");
  return +result;
};
